import { render } from "./team-goal.svg?vue&type=template&id=030682eb"
const script = {}
script.render = render

export default script